module.exports = __webpack_public_path__ + "static/media/Logo.9052fae6.jpeg";